/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Group_ClassesInputs */

const en_service_type_group_classes = /** @type {(inputs: Service_Type_Group_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs and classes`)
};

const pl_service_type_group_classes = /** @type {(inputs: Service_Type_Group_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kluby i zajęcia`)
};

/**
* | output |
* | --- |
* | "Clubs and classes" |
*
* @param {Service_Type_Group_ClassesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_group_classes = /** @type {((inputs?: Service_Type_Group_ClassesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Group_ClassesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_group_classes(inputs)
	return en_service_type_group_classes(inputs)
});